import React from 'react';
import { Button } from '@stepstone-genesis/components';
export const FeedbackButton = ({ a11yLabel, filled, iconEmpty, iconFilled, isDisabled, handleClick, }) => {
    return (React.createElement(Button, { disabled: isDisabled, iconOnly: filled ? iconFilled : iconEmpty, variant: "link", a11yLabel: a11yLabel, onClick: handleClick, size: "xs" }));
};
export default FeedbackButton;
